import { useEffect, useRef, useState, useCallback } from "react";
import { jwtDecode } from "jwt-decode";

export const useIntersection = ({ root = null, rootMargin, threshold = 0 }) => {
  const [entry, updateEntry] = useState({});
  const [node, setNode] = useState(null);
  const observer = useRef(
    new window.IntersectionObserver(([entry]) => updateEntry(entry), {
      root,
      rootMargin,
      threshold,
    })
  );
  useEffect(() => {
    const { current: currentObserver } = observer;
    currentObserver.disconnect();
    if (node) currentObserver.observe(node);
    return () => currentObserver.disconnect();
  }, [node]);
  return [setNode, entry];
};

// Debounce utility
export const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

function checkRemainingTime(token, setRemainingTime) {
  if (token) {
    const decoded = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / 1000);
    const remainingSessionTime = decoded.exp - currentTime;
    setRemainingTime(remainingSessionTime)
  }
}

const useActivityTracker = (
  logoutAction,
  getRefreshTokenAction,
  timeout = 7200000
) => {
  const [isUserActive, setIsUserActive] = useState(true);
  const [lastActivityTime, setLastActivityTime] = useState(Date.now());
  const isLoggingOutRef = useRef(false); // Use ref to track logout state
  const [remainingTime, setRemainingTime] = useState(0); 
  const token = localStorage.getItem("token");

  const channel = new BroadcastChannel("activity_channel");

  const updateActivity = useCallback(
    debounce(() => {
      const currentTime = Date.now();
      setLastActivityTime(currentTime);
      localStorage.setItem("lastActivityTime", currentTime);
      setIsUserActive(true);
      checkRemainingTime(token, setRemainingTime)
      // Broadcast activity update
      channel.postMessage({
        type: "activity-update",
        lastActivityTime: currentTime,
      });
    }, 1000), // Debounce time
    [channel]
  );

  const handleLogout = useCallback(() => {
    console.log("isLoggingOut", isLoggingOutRef.current);
    if (isLoggingOutRef.current) return; // Use the ref to check logout state
    isLoggingOutRef.current = true;
    console.log("Logging out user due to inactivity");
    channel.postMessage({ type: "logout" });
    logoutAction();
    localStorage.setItem("LogoutFromFunc", JSON.stringify(true));
  }, []);

  const refreshToken = useCallback(async (payload) => {
    getRefreshTokenAction(payload);
    // console.log("Token refreshed successfully");
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === "activity-update") {
        // console.log("Received activity-update from another tab");
        setLastActivityTime(event.data.lastActivityTime);
      }
      if (event.data.type === "logout") {
        // console.log("Received logout message from another tab");
        handleLogout();
      }
    };

    channel.addEventListener("message", handleMessage);

    const handleUserActivity = () => updateActivity();

    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("keydown", handleUserActivity);
    window.addEventListener("click", handleUserActivity);
    // checkRemainingTime(token, setRemainingTime)

    const checkSession = setInterval(() => {
      if (token) {
        const decoded = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
        const currentTimePlusFive = currentTime + 300; // Add 5 minutes (300 seconds)
        // const currentTimePlusFive = currentTime + 13; // Add 13
        const expTime = decoded.exp;

        // const expTimeInString = new Date(decoded.exp * 1000).toLocaleString();
        // const iatInString = new Date(decoded.iat * 1000).toLocaleString();
        // const currentTimeInString = new Date(
        //   currentTime * 1000
        // ).toLocaleString();
        // const lastActivityTimeInString = new Date(
        //   lastActivityTime
        // ).toLocaleString();

        // console.log("Token Start Time :", iatInString);
        // console.log("currentTimeInString:", currentTimeInString);
        // console.log("expTimeInString:", expTimeInString);
        // console.log("lastActivityTimeInString:", lastActivityTimeInString);

        // checkRemainingTime(token, setRemainingTime)
        // const remainingSessionTime = decoded.exp - currentTime;

        console.log("currentTimePlusFive", new Date(currentTimePlusFive * 1000).toLocaleString());
        console.log("expTime",  new Date(expTime * 1000).toLocaleString());
        
        // if (currentTimePlusFive >= expTime) {
        if (currentTimePlusFive >= expTime) {
          // const Time = expTime - lastActivityTime;
          // const temp = lastActivityTime + 7200000; // 2 hrs
          const temp = lastActivityTime + 600000; //  10 min
          const totaltime = temp - expTime * 1000;
          const timeInMinutes = totaltime / (1000 * 60);

          checkRemainingTime(token, setRemainingTime)
          
          console.log("totaltime",totaltime);
          
          // 5 minutes 300000
          if (totaltime > 120000) {
          // if (totaltime > 13000) {
            // Token_time = lastActivityTime;
            const timeInMinutes = Math.ceil(totaltime / (1000 * 60));
            console.log("Refresh token");
            refreshToken({ minutes: timeInMinutes });
          } else {
            handleLogout();
          }
        }
      }
    // }, 2000);
    }, 1000); // 2 * 60 * 1000 , 2 mins

    return () => {
      // channel.removeEventListener("message", handleMessage);
      // window.removeEventListener("mousemove", handleUserActivity);
      // window.removeEventListener("keydown", handleUserActivity);
      // window.removeEventListener("click", handleUserActivity);
      clearInterval(checkSession);
    };
  }, [
    lastActivityTime,
    timeout,
    updateActivity,
    handleLogout,
    refreshToken,
    channel,
  ]);

  return { isUserActive, remainingTime };
};

export default useActivityTracker;
